module.exports = __webpack_public_path__ + "media/images/common/login_btn-c7760e41e336ca28141204ce4b83e796.gif";